module.exports = __webpack_public_path__ + "Flag-336.92bf97c093903eb76184a4c4d6403140.svg";